import { ReactComponent as ChatIcon } from '~/assets/svg/conversation.svg';
import { ReactComponent as StatsIcon } from '~/assets/svg/stats.svg';
import { ReactComponent as SettingsIcon } from '~/assets/svg/settings.svg';
import { ReactComponent as CampaignIcon } from '~/assets/svg/campaign.svg';
import { ReactComponent as PaymentIcon } from '~/assets/svg/payments.svg';
import { ReactComponent as UserGroupIcon } from '~/assets/svg/UserGroup.svg';
import { ReactComponent as PuzzlePieceIcon } from '~/assets/svg/puzzle.svg';
import { ReactComponent as StoreIcon } from '~/assets/svg/store.svg';
import { ReactComponent as TrainingIcon } from '~/assets/svg/training.svg';
import { ReactComponent as ScheduleIcon } from '~/assets/svg/schedule_icon.svg';
import { ReactComponent as CustomersIcon } from '~/assets/svg/customers.svg';
import { ReactComponent as FormsIcon } from '~/assets/svg/forms.svg';

import { APP_DOMAINS } from '~/types';

export interface SubRoute {
  label: string;
  route: string;
}

export interface Route {
  label: string;
  icon: string | React.ComponentType;
  routes?: SubRoute[];
}

export interface NavigationProps {
  setAppDomain: React.Dispatch<React.SetStateAction<APP_DOMAINS | null>>;
  appDomain: APP_DOMAINS | null;
  routes: Record<APP_DOMAINS, Route>;
}

export const ROUTES: Partial<Record<APP_DOMAINS, Route>> = {
  [APP_DOMAINS.CONVERSATIONS]: {
    label: APP_DOMAINS.CONVERSATIONS,
    icon: ChatIcon,
    routes: [
      {
        label: 'inbox',
        route: APP_DOMAINS.CONVERSATIONS,
      },
    ],
  },

  [APP_DOMAINS.COLLAB]: {
    label: APP_DOMAINS.COLLAB,
    icon: UserGroupIcon,
    routes: [
      {
        label: 'collaboration',
        route: APP_DOMAINS.COLLAB,
      },
    ],
  },

  [APP_DOMAINS.CAMPAIGNS]: {
    label: APP_DOMAINS.CAMPAIGNS,
    icon: CampaignIcon,
    routes: [
      {
        label: 'campaigns',
        route: 'campaigns',
      },
    ],
  },
  [APP_DOMAINS.STATS]: {
    label: APP_DOMAINS.STATS,
    icon: StatsIcon,
    routes: [
      {
        label: 'stats',
        route: 'stats',
      },
    ],
  },
  [APP_DOMAINS.TRAINING]: {
    label: APP_DOMAINS.TRAINING,
    icon: TrainingIcon,
    routes: [
      {
        label: 'training',
        route: 'training',
      },
    ],
  },
  [APP_DOMAINS.SETTINGS]: {
    label: APP_DOMAINS.SETTINGS,
    icon: SettingsIcon,
    routes: [
      {
        label: 'advanced',
        route: 'settings/users',
      },
    ],
  },

  [APP_DOMAINS.BILLING]: {
    label: APP_DOMAINS.BILLING,
    icon: PaymentIcon,
    routes: [
      {
        label: 'subscription',
        route: 'billing',
      },
    ],
  },

  /*
  [APP_DOMAINS.TEAMS]: {
    label: APP_DOMAINS.TEAMS,
    icon: UserGroupIcon,
    routes: [
      // {
      //   label: 'equipment',
      //   route: 'teams/teams',
      // },
      {
        label: 'users',
        route: 'teams/users',
      },
      {
        label: 'tags',
        route: 'teams/tags',
      },
    ],
  },
  */

  [APP_DOMAINS.INTEGRATIONS]: {
    label: APP_DOMAINS.INTEGRATIONS,
    icon: PuzzlePieceIcon,
    routes: [
      {
        label: 'integrations',
        route: 'integrations',
      },
    ],
  },
  [APP_DOMAINS.STORE]: {
    label: APP_DOMAINS.STORE,
    icon: StoreIcon,
    routes: [
      {
        label: 'store',
        route: 'store',
      },
    ],
  },
  [APP_DOMAINS.SCHEDULE]: {
    label: APP_DOMAINS.SCHEDULE,
    icon: ScheduleIcon,
    routes: [
      {
        label: 'schedule',
        route: 'schedule',
      },
    ],
  },
  [APP_DOMAINS.CUSTOMERS]: {
    label: APP_DOMAINS.CUSTOMERS,
    icon: CustomersIcon,
    routes: [
      {
        label: 'customers',
        route: 'customers',
      },
    ],
  },

  [APP_DOMAINS.FORMS]: {
    label: APP_DOMAINS.FORMS,
    icon: FormsIcon,
    routes: [
      {
        label: 'forms',
        route: 'forms',
      },
    ],
  },
};
